import {
    SHOW_SKETCH,
    HIDE_SKETCH,
} from './actionTypes';

export const showSketch = (orderId, projectId) => ({
    type: SHOW_SKETCH,
    orderId,
    projectId,
});

export const hideSketch = () => ({
    type: HIDE_SKETCH,
});
